// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2LdRR","group":"Checkbox_group__3KO2c"};